export const EVENT_PARTICIPANT_CONFIRMED = "confirmed";
export const EVENT_PARTICIPANT_INTERESTED = "interested";
